"use client";

import React from "react";

//type
import type { InputGroupDescriptionProps } from "@/types";

//Style
import * as S from "./styles";
import LabelInput from "@/components/label";

const InputIconGroupDescription: React.FC<
  Omit<InputGroupDescriptionProps, "onChange"> & {
    onChange: (
      e:
        | React.ChangeEvent<HTMLInputElement>
        | { target: { name: string; value: any } },
    ) => void;
  }
> = ({
  className,
  placeholder,
  name,
  value,
  onChange,
  DescriptionInput,
  type,
  label,
}) => {
  return (
    <>
      {label && <LabelInput labelInput={label} />}
      <S.InputGroup className={className}>
        <S.InputComponent
          name={name}
          placeholder={placeholder}
          type={type}
          value={value}
          onChange={onChange}
        />
        <S.BoxDescription>{DescriptionInput}</S.BoxDescription>
      </S.InputGroup>
    </>
  );
};

export default InputIconGroupDescription;
